import api from "./api";

export const getFiscalConfig = (companyId) => {
  return api.get(`/fiscal/config/${companyId}`);
};

export const saveFiscalConfig = (companyId, data) => {
  return api.post(`/fiscal/config/${companyId}`, data);
};

export const validateFiscalReadiness = (companyId) => {
  return api.get(`/fiscal/validate/${companyId}`);
};

export const generateInvoiceFromOrder = (orderId) => {
  return api.post(`/fiscal/generate-invoice/${orderId}`);
};

export const processAutomaticInvoicing = () => {
  return api.post("/fiscal/process-automatic");
};

export const sendInvoiceToNapp = (invoiceId) => {
  return api.post(`/fiscal/send-to-napp/${invoiceId}`);
};

export const checkSefazStatus = (nfeKey) => {
  return api.get(`/fiscal/sefaz-status/${nfeKey}`);
};

export const cancelInvoice = (invoiceId, reason) => {
  return api.post(`/fiscal/cancel-invoice/${invoiceId}`, { reason });
};

export const getFiscalStats = (companyId, params = {}) => {
  return api.get(`/fiscal/stats/${companyId}`, { params });
};

export const getInvoiceXml = (invoiceId) => {
  return api.get(`/fiscal/xml/${invoiceId}`, {
    responseType: "blob",
  });
};

export const getInvoiceDanfe = (invoiceId) => {
  return api.get(`/fiscal/danfe/${invoiceId}`, {
    responseType: "blob",
  });
};

export const deactivateFiscalConfig = (companyId) => {
  return api.delete(`/fiscal/config/${companyId}`);
};